import {useEffect} from 'react'
import {useRouter} from 'next/router'
import type {AppProps} from 'next/app'
// Contexts
import {Toaster} from 'react-hot-toast'
import {SessionProvider} from 'next-auth/react'
import {BallotVoterProvider} from '../providers/ballot-voter-provider'
// FontAwesome Icons
import '@fortawesome/fontawesome-svg-core/styles.css'
import {config, library} from '@fortawesome/fontawesome-svg-core'
import {fas} from '@fortawesome/free-solid-svg-icons'
import {fab} from '@fortawesome/free-brands-svg-icons'
// Uploadcare styles
import '@uploadcare/file-uploader/web/uc-file-uploader-minimal.min.css'
import '@uploadcare/file-uploader/web/uc-file-uploader-inline.min.css'
// Global styles
import '../styles/global.scss'
// Types
import type {Ballot} from '../types/ballot'

config.autoAddCss = false
library.add(fas, fab)

interface CustomPageProps {
  session?: any
  initBasicBallot?: Ballot | null
  [key: string]: any
}

const App = ({
  Component,
  pageProps,
}: AppProps<CustomPageProps>) => {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChange = (url: string) => {
      // TODO: No further need for GA, I don't think. If so, reenable.
      // window.gtag && window.gtag('config', 'G-BQ2HQZ6KQ7')

      if (url === '/[group_slug]/[question_slug]') {
        document.body.style.overflow = 'hidden'
      } else {
        document.body.style.overflow = 'visible'
      }
    }

    handleRouteChange(router.pathname)
    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
      document.body.style.overflow = 'visible'
    }
  }, [router])

  return <>
    <SessionProvider session={pageProps.session}>
      <BallotVoterProvider
        initBasicBallot={pageProps.initBasicBallot}
      >
        <Component {...pageProps} />
        <Toaster position="bottom-center" />
      </BallotVoterProvider>
    </SessionProvider>
  </>
}

export default App
